import React from 'react';
import './../App.css';
import X49Hull from './X49Hull';
import { Route, Switch, Redirect  } from "react-router-dom";
import X49BowSprit from './X49BowSprit';
import X49HullTreatment from './X49HullTreatment';
import X49Transom from './X49Transom';
import X49Deck from './X49Deck';
import X49Sprayhood from './X49Sprayhood';
import X49Wheel from './X49Wheel';
import X49Mast from './X49Mast';
import X49Interior from './X49Interior';
import X49Galley from './X49Galley';
import X49Fabric from './X49Fabric';
import X49Saloon from './X49Saloon';
import X49OwnersCabin from './X49OwnersCabin';
import X49AftCabin from './X49AftCabin';
import Logo from './x49-logo.svg';
import X49Summary from './X49Summary';
import X49BathingPlatform from './X49BathingPlatform';

import hullColor11 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x light grey RAL 7035 waterliness.jpg';
import hullColor12 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x black grey RAL 702 waterlines.jpg';
import hullColor13 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x dark blue RAL 5011 waterlines.jpg';
import hullColor14 from '../assets/hullColors/Hull colour - light grey RAL 7035 & 3 x pure white RAL 9010 waterlines.jpg';
import hullColor15 from '../assets/hullColors/Hull colour - black grey RAL 7021 & 3 x pure white RAL 9010 waterlines.jpg';

import fabric1 from '../assets/fabrics/JustFleckless–01Nature.jpg';
import fabric2 from '../assets/fabrics/JustFleckless–05Camel.jpg';
import fabric3 from '../assets/fabrics/JustFleckless–10Navy.jpg';
import fabric4 from '../assets/fabrics/JustFleckless–403Bambus.jpg';
import fabric5 from '../assets/fabrics/JustFleckless–710MoonGrey.jpg';
import fabric6 from '../assets/fabrics/JustFleckless–750OliveGrey.jpg';
import fabric7 from '../assets/fabrics/AlsaceBlue.jpg';
import fabric8 from '../assets/fabrics/AlsaceIvory.jpg';
import fabric9 from '../assets/fabrics/AlsaceSand.jpg';
import fabric10 from '../assets/fabrics/Nubilux709Argent.jpg';

import galley1 from '../assets/galleyColors/camoan_white_corian.jpg';
import galley2 from '../assets/galleyColors/black_quartz_corian.jpg';

import veneer1 from '../assets/interiorColors/nordic_oak.jpg';
import veneer2 from '../assets/interiorColors/teak.jpg';

import laminate1 from '../assets/interiorColors/teak_without_koto.jpg';
import laminate2 from '../assets/interiorColors/walnut.jpg';
import laminate3 from '../assets/interiorColors/teak_with_koto.jpg';

import sprayhood1 from '../assets/sprayhoodColors/without.jpg';
import sprayhood2 from '../assets/sprayhoodColors/Dark grey.jpg';
import sprayhood3 from '../assets/sprayhoodColors/Taupe.jpg';
import sprayhood4 from '../assets/sprayhoodColors/Captains blue.jpg';
import sprayhood5 from '../assets/sprayhoodColors/Silver grey.jpg';

import ConfiguratorContainer from '../ConfiguratorContainer';
import { withTranslation } from 'react-i18next';

class X49Container extends ConfiguratorContainer {
    constructor(props) {
        super(props);

        this.logo = Logo;
        this.logoLink = 'https://www.x-yachts.com/en/yachts/x/x4-9/';

        this.HullColourOptions = [
            { value: 1, label: this.props.t('Pure White'), description: this.props.t('(RAL 9010) & 3 x Light Grey (RAL 7035) integrated Gelcoat Water Lines'), preview: hullColor11 },
            { value: 2, label: this.props.t('Pure White'), description: this.props.t('(RAL 9010) & 3 x Black Grey (RAL 7021) integrated Gelcoat Water Lines'), preview: hullColor12 },
            { value: 3, label: this.props.t('Pure White'), description: this.props.t('(RAL 9010) & 3 x Dark Blue (RAL 5011) integrated Gelcoat Water Lines'), preview: hullColor13 },
            { value: 4, label: this.props.t('Light Grey'), description: this.props.t('(RAL 7035) & 3 x Pure White (RAL 9010) integrated Gelcoat Water Lines'), preview: hullColor14 },
            { value: 5, label: this.props.t('Black Grey'), description: this.props.t('(RAL 7021) & 3 x Pure White (RAL 9010) integrated Gelcoat Water Lines'), preview: hullColor15 }
        ];

        this.BowSpritOptions = [
            { value: 1, label: this.props.t('Standard GRP cowl'), description: this.props.t('(without bowsprit)') },
            { value: 2, label: this.props.t('Painted carbon fibre bow sprit'), description: this.props.t('(will match hull color)') },
            { value: 3, label: this.props.t('Clear coated carbon fibre bowsprit') }
        ];

        this.HullTreatmentOptions = [
            { value: 1, label: this.props.t('White') },
            { value: 2, label: this.props.t('Black') },
            { value: 3, label: this.props.t('Copper') }
        ];

        this.DeckOptions = [
            { value: 1, label: this.props.t('Genuine teak with black caulkings') },
            { value: 2, label: this.props.t('Flexiteek with grey stripes') }
        ];

        this.SprayhoodOptions = [
            { value: 1, label: this.props.t('Without'), thumbnail: sprayhood1 },
            { value: 2, label: this.props.t('Dark grey'), thumbnail: sprayhood2 },
            { value: 3, label: this.props.t('Taupe'), thumbnail: sprayhood3 },
            { value: 4, label: this.props.t('Captains blue'), thumbnail: sprayhood4 },
            { value: 5, label: this.props.t('Silver grey'), thumbnail: sprayhood5 }
        ];

        this.WheelOptions = [
            { value: 1, label: this.props.t('Steel wheel') },
            { value: 2, label: this.props.t('Composite wheel black') },
            { value: 3, label: this.props.t('Composite wheel white') }
        ];

        this.MastAndBoomOptions = [
            { value: 1, label: this.props.t('Aluminium') },
            { value: 2, label: this.props.t('White painted carbon') },
            { value: 3, label: this.props.t('Black painted carbon') },
            { value: 4, label: this.props.t('Clear coated carbon') }
        ];

        this.VeneerOptions = [
            { value: 1, label: this.props.t('Nordic oak (standard)'), thumbnail: veneer1 },
            { value: 2, label: this.props.t('Modern teak (optional)'), thumbnail: veneer2 }
        ];

        this.FloorboardOptions = [
            { value: 1, label: this.props.t('Teak laminate (standard)'), thumbnail: laminate1 },
            { value: 2, label: this.props.t('Walnut laminate (optional)'), thumbnail: laminate2 },
            { value: 3, label: this.props.t('Teak with inlay stripes / holly (optional)'), thumbnail: laminate3 }
        ];

        this.WorktopOptions = [
            { value: 1, label: this.props.t('Worktop in Camoan white Corian'), thumbnail: galley1 },
            { value: 2, label: this.props.t('Worktop in black quartz Corian'), thumbnail: galley2 }
        ];

        this.FabricOptions = [
            { value: 1, label: this.props.t('Just Fleckless – 01 Nature'), thumbnail: fabric1 },
            { value: 2, label: this.props.t('Just Fleckless – 05 Camel'), thumbnail: fabric2 },
            { value: 3, label: this.props.t('Just Fleckless – 10 Navy'), thumbnail: fabric3 },
            { value: 4, label: this.props.t('Just Fleckless – 403 Bambus'), thumbnail: fabric4 },
            { value: 5, label: this.props.t('Just Fleckless – 710 Moon Grey'), thumbnail: fabric5 },
            { value: 6, label: this.props.t('Just Fleckless – 750 Olive Grey'), thumbnail: fabric6 },
            { value: 7, label: this.props.t('Alsace Blue'), thumbnail: fabric7 },
            { value: 8, label: this.props.t('Alsace Ivory'), thumbnail: fabric8 },
            { value: 9, label: this.props.t('Alsace Sand'), thumbnail: fabric9 },
            { value: 10, label: this.props.t('Nubilux 709 Argent'), thumbnail: fabric10 }
        ];

        this.SplitBerthOptions = [
            { value: 2, label: this.props.t('Double berth'), description: this.props.t('(standard)') },
            { value: 1, label: this.props.t('Split berth'), description: this.props.t('(optional)') }
        ];

        this.state = Object.assign(this.state, {
            boat: "X49",
            exterior: {
                HullColour: this.HullColourOptions[0],
                BowSprit: this.BowSpritOptions[0],
                HullTreatment: this.HullTreatmentOptions[0],
                Deck: this.DeckOptions[0],
                TeakOnSideDecks: { value: 1, label: 'false' },
                TeakOnCoachroof: { value: 1, label: 'false' },
                TeakOnBathingPlatform: { value: 2, label: 'true' },
                SprayHood: this.SprayhoodOptions[0],
                Wheel: this.WheelOptions[0],
                Boom: { value: 1, label: 'false' },
                MastAndBoom: this.MastAndBoomOptions[0]
            },
            transom: {
                Name: {
                    verticalOffset: 0,
                    color: this.colorOptions[2],
                    value: this.props.t('My yacht'),
                    font: this.fontOptions[0],
                    size: this.sizeOptions[2],
                    horizontalOffset: 0
                },
                Port: {
                    verticalOffset: 350,
                    color: this.colorOptions[2],
                    value: this.props.t('Harbor'),
                    font: this.fontOptions[0],
                    size: this.sizeOptions[1],
                    horizontalOffset: 0
                }
            },
            interior: {
                Veneer:  this.VeneerOptions[0],
                Floorboard: this.FloorboardOptions[0],
                Worktop: this.WorktopOptions[0],
                Fabric: this.FabricOptions[0],
                BeautyBox: { value: 1, label: 'false' },
                Pouffes: { value: 1, label: 'false' },
                CupboardsSaloon: { value: 1, label: 'false' },
                CupboardsOwnersCabin: { value: 1, label: 'false' },
                SplitBerth: this.SplitBerthOptions[0],
                Backrest: { value: 1, label: 'false' },
                TableBox: { value: 1, label: 'false' },
                CupboardsAftCabin: { value: 1, label: 'false' }
            }
        });

        this.steps = [
            { name: this.props.t('Hull colourways'), url: '/x49/hull' },
            { name: this.props.t('Bowsprit'), url: '/x49/bowsprit' },
            { name: this.props.t('Hull treatment'), url: '/x49/hulltreatment' },
            { name: this.props.t('Boat name'), url: '/x49/transom' },
            { name: this.props.t('Deck'), url: '/x49/deck' },
            { name: this.props.t('Bathing platform'), url: '/x49/bathingplatform' },
            { name: this.props.t('Mast & boom'), url: '/x49/mast' },
            { name: this.props.t('Wheels'), url: '/x49/wheel' },
            { name: this.props.t('Sprayhood'), url: '/x49/sprayhood' },

            { name: this.props.t('Interior surfaces'), url: '/x49/surfaces' },
            { name: this.props.t('Saloon furniture'), url: '/x49/saloon' },
            { name: this.props.t('Interior Fabric'), url: '/x49/fabric' },
            { name: this.props.t('Galley'), url: '/x49/galley' },
            { name: this.props.t('Owner’s cabin'), url: '/x49/ownerscabin' },
            { name: this.props.t('Aft cabins'), url: '/x49/aftcabin' },
            
            { name: this.props.t('Summary'), url: '/x49/summary' }
        ];


        this.handleHullConfigurationChange = this.handleHullConfigurationChange.bind(this);
    }

    handleHullConfigurationChange(newConfiguration) {
        let transom = this.state.transom;
        switch (newConfiguration.HullColour.value) {
            case 1:
                transom.Name.color = this.colorOptions[2];
                transom.Port.color = this.colorOptions[2];
                break;
            case 2:
                transom.Name.color = this.colorOptions[3];
                transom.Port.color = this.colorOptions[3];
                break;
            case 3:
                transom.Name.color = this.colorOptions[4];
                transom.Port.color = this.colorOptions[4];
                break;
            case 4:
            case 5:
                transom.Name.color = this.colorOptions[1];
                transom.Port.color = this.colorOptions[1];
                break;
            default:
                break;

        }

        super.handleTransomChange(transom);
        super.handleExteriorConfigurationChange(newConfiguration);
    }

    generateCode() {
        let data = [];
        data.push("x49");

        data.push([]);
        let exterior = this.state.exterior;
        for (const key in exterior) {
            if (exterior.hasOwnProperty(key)) {
                let element = exterior[key].value;
                data[data.length - 1].push(element);
            }
        }

        data.push([]);
        data[data.length - 1].push([]);
        data[data.length - 1].push([]);

        let transom = this.state.transom;
        data[data.length - 1][0].push(transom.Name.value);
        data[data.length - 1][0].push(transom.Name.font.value);
        data[data.length - 1][0].push(transom.Name.size.value);
        data[data.length - 1][0].push(transom.Name.color.value);
        data[data.length - 1][0].push(transom.Name.horizontalOffset);
        data[data.length - 1][0].push(transom.Name.verticalOffset);

        data[data.length - 1][1].push(transom.Port.value);
        data[data.length - 1][1].push(transom.Port.font.value);
        data[data.length - 1][1].push(transom.Port.size.value);
        data[data.length - 1][1].push(transom.Port.color.value);
        data[data.length - 1][1].push(transom.Port.horizontalOffset);
        data[data.length - 1][1].push(transom.Port.verticalOffset);

        data.push([]);
        let interior = this.state.interior;
        for (const key in interior) {
            if (interior.hasOwnProperty(key)) {
                let element = interior[key].value;
                data[data.length - 1].push(element);
            }
        }
        
        var json = JSON.stringify(data);
        return btoa(json);
    }

    parseCode(code) {
        let json = JSON.parse(atob(code));

        if (json[0] !== 'x49') {
            return;
        }

        let exterior = this.state.exterior;
        exterior.HullColour = this.HullColourOptions.find(v => v.value === json[1][0]) || this.HullColourOptions[0];
        exterior.BowSprit = this.BowSpritOptions.find(v => v.value === json[1][1]) || this.BowSpritOptions[0];
        exterior.HullTreatment = this.HullTreatmentOptions.find(v => v.value === json[1][2]) || this.HullTreatmentOptions[0];
        exterior.Deck = this.DeckOptions.find(v => v.value === json[1][3]) || this.DeckOptions[0];
        exterior.TeakOnSideDecks = { value: +json[1][4] || 1, label: '' };
        exterior.TeakOnCoachroof = { value: +json[1][5] || 1, label: '' };
        exterior.TeakOnBathingPlatform = { value: +json[1][6] || 1, label: '' };
        exterior.SprayHood = this.SprayhoodOptions.find(v => v.value === json[1][7]) || this.SprayhoodOptions[0];
        exterior.Wheel = this.WheelOptions.find(v => v.value === json[1][8]) || this.WheelOptions[0];
        exterior.Boom = { value: +json[1][9] || 1, label: '' };
        exterior.MastAndBoom = this.MastAndBoomOptions.find(v => v.value === json[1][10]) || this.MastAndBoomOptions[0];

        let transom = this.state.transom;
        transom.Name.value = json[2][0][0] || '';
        transom.Name.font = this.fontOptions.find(v => v.value === json[2][0][1]) || this.fontOptions[0];
        transom.Name.size = this.sizeOptions.find(v => v.value === json[2][0][2]) || this.sizeOptions[0];
        transom.Name.color = this.colorOptions.find(v => v.value === json[2][0][3]) || this.colorOptions[0];
        transom.Name.horizontalOffset = +json[2][0][4] || 1;
        transom.Name.verticalOffset = +json[2][0][5] || 1;

        transom.Port.value = json[2][1][0] || '';
        transom.Port.font = this.fontOptions.find(v => v.value === json[2][1][1]) || this.fontOptions[0];
        transom.Port.size = this.sizeOptions.find(v => v.value === json[2][1][2]) || this.sizeOptions[0];
        transom.Port.color = this.colorOptions.find(v => v.value === json[2][1][3]) || this.colorOptions[0];
        transom.Port.horizontalOffset = +json[2][1][4] || 1;
        transom.Port.verticalOffset = +json[2][1][5] || 1;
        
        let interior = this.state.interior;
        interior.Veneer = this.VeneerOptions.find(v => v.value === json[3][0]) || this.VeneerOptions[0];
        interior.Floorboard = this.FloorboardOptions.find(v => v.value === json[3][1]) || this.FloorboardOptions[0];
        interior.Worktop = this.WorktopOptions.find(v => v.value === json[3][2]) || this.WorktopOptions[0];
        interior.Fabric = this.FabricOptions.find(v => v.value === json[3][3]) || this.FabricOptions[0];
        interior.BeautyBox = { value: +json[3][4] || 1, label: '' };
        interior.Pouffes = { value: +json[3][5] ||1, label: '' };
        interior.CupboardsSaloon = { value: +json[3][6] || 1, label: '' };
        interior.CupboardsOwnersCabin = { value: +json[3][7] || 1, label: '' };
        interior.SplitBerth = this.SplitBerthOptions.find(v => v.value === json[3][8]) || this.SplitBerthOptions[0];
        interior.Backrest = { value: +json[3][9] || 1, label: '' };
        interior.TableBox = { value: +json[3][10] || 1, label: '' };
        interior.CupboardsAftCabin = { value: +json[3][11] || 1, label: '' };


        
        
        this.setState(this.state);
    }


    renderSteps() {
        return (
            <Switch location={this.props.location}>
                <Route exact path="/x49" render={() => <Redirect to="/x49/hull" />} />

                <Route path="/x49/hull" render={(props) => <X49Hull {...props} onChange={this.handleHullConfigurationChange} onCodeSubmitted={this.parseCode} configuration={this.state.exterior} hullColourOptions={this.HullColourOptions} />} />
                <Route path="/x49/bowsprit" render={(props) => <X49BowSprit {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} bowSpritOptions={this.BowSpritOptions} />} />
                <Route path="/x49/hulltreatment" render={(props) => <X49HullTreatment {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} hullTreatmentOptions={this.HullTreatmentOptions} />} />
                <Route path="/x49/transom" render={(props) => <X49Transom {...props} onChange={this.handleTransomChange} configuration={this.state.exterior} transom={this.state.transom} fontOptions={this.fontOptions} sizeOptions={this.sizeOptions} colorOptions={this.colorOptions} />} />
                <Route path="/x49/deck" render={(props) => <X49Deck {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} deckOptions={this.DeckOptions} />} />
                <Route path="/x49/bathingplatform" render={(props) => <X49BathingPlatform {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} />} />
                <Route path="/x49/sprayhood" render={(props) => <X49Sprayhood {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} sprayhoodOptions={this.SprayhoodOptions} />} />
                <Route path="/x49/wheel" render={(props) => <X49Wheel {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} wheelOptions={this.WheelOptions} />} />
                <Route path="/x49/mast" render={(props) => <X49Mast {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} transom={this.state.transom} mastAndBoomOptions={this.MastAndBoomOptions} />} />

                <Route path="/x49/surfaces" render={(props) => <X49Interior {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} veneerOptions={this.VeneerOptions} floorboardOptions={this.FloorboardOptions} />} />
                <Route path="/x49/saloon" render={(props) => <X49Saloon {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} />} />
                <Route path="/x49/fabric" render={(props) => <X49Fabric {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} fabricOptions={this.FabricOptions} />} />
                <Route path="/x49/galley" render={(props) => <X49Galley {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} worktopOptions={this.WorktopOptions} />} />
                <Route path="/x49/aftcabin" render={(props) => <X49AftCabin {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} aftCabinOptions={this.SplitBerthOptions} />} />
                <Route path="/x49/ownerscabin" render={(props) => <X49OwnersCabin {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} />} />

                <Route path="/x49/summary" render={(props) => <X49Summary {...props} country={this.state.country} countries={this.state.countries} code={this.generateCode()} configuration={{ exterior: this.state.exterior, interior: this.state.interior, transom: this.state.transom }} />} />
            </Switch>
        );
    }
}

export default withTranslation()(X49Container);


// WEBPACK FOOTER //
// ./src/X49/X49Container.js